import React, { useState, useEffect } from 'react'

/** ********************* */
interface CacheProp {
  [key: string]: { data: string }
}

interface DefaultValProp {
  data: string
}
/** ********************* */

const defaultVal: DefaultValProp = { data: '' }

const CACHE: CacheProp = {}

export const useStaleRefresh = function (
  url: string,
  defaultValue = defaultVal
): [DefaultValProp, boolean] {
  const [data, setData] = useState(defaultValue)
  const [isLoading, setLoading] = useState(true)

  useEffect(() => {
    // cacheID is how a cache is identified against a unique request
    const cacheID = url
    // look in cache and set response if present
    if (CACHE[cacheID] !== undefined) {
      if (CACHE[cacheID] && CACHE[cacheID]) {
        setData(CACHE[cacheID])
      }
      setLoading(false)
    } else {
      // else make sure loading set to true
      setLoading(true)
      setData(defaultValue)
    }

    const fetchData = async () => {
      // fetch new data
      await fetch(url)
        .then((res) => {
          return res.json()
        })
        .then((newData) => {
          CACHE[cacheID] = { data: newData.slice(0, 5) }
          setData({ data: newData.slice(0, 5) })
          setLoading(false)
        })
    }
    fetchData()
  }, [url, defaultValue])

  return [data, isLoading]
}

function DataComponent({ url }: { url: string }) {
  const [data, isLoading] = useStaleRefresh(url, defaultVal)
  if (isLoading) {
    return <div>loading</div>
  }

  return (
    <pre className="col-12 text-light bg-dark p-4">
      {JSON.stringify(data.data, null, 2)}
    </pre>
  )
}

export default DataComponent
